export const KEY_WORD_AUTHENTICATED_USER = 'FLUX_CONTROL.K';
